import { useRef } from 'react'
import { StickyNote, Plus } from 'lucide-react'
import NotesTab from '../JobApplication/NotesTab'
import SectionBlock from '../UI/SectionBlock'
import SectionHeader from '../UI/SectionHeader'

const NotesSection = ({ talentId, talentType, hasPermission }) => {
  const notesRef = useRef(null)

  return (
    <SectionBlock id="notes">
      <SectionHeader
        icon={StickyNote}
        title="Notes"
        action={hasPermission('talent-service', `${talentType}_notes`, 'create') ? (
          <button
            onClick={() => notesRef.current?.openForm()}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary-600 text-white text-xs font-medium rounded-lg hover:bg-primary-700 dark:bg-primary-500 dark:hover:bg-primary-600 transition-colors"
          >
            <Plus className="h-3.5 w-3.5" />Add Note
          </button>
        ) : null}
      />
      <NotesTab ref={notesRef} talentId={talentId} entityType="Talent" talentType={talentType} showAddButton={false} />
    </SectionBlock>
  )
}

export default NotesSection
